import { CLICK_AREA, CUG_TYPE, ROOM_TYPE } from './constants';
import { getPriceInfoCardArea } from './hotels-action';

import type { Maybe, Nullable } from '@shared/types/utils';

export const HOTEL_PRICES_SCHEMA_NAME = 'hotel_prices.HotelPricesAction';
export const HOTEL_PRICES_MINIEVENT_NAME = 'HotelsFrontendHotelPrices';

export const buildAdditionalInfoPriceSelectedInfo = ({
  basePrice,
  campaignName,
  chatSessionId,
  clickArea,
  correlationId,
  cugType,
  currency,
  dayviewCorrelationId,
  discountPercentage,
  groupName,
  hasAISummary,
  hasRedirect,
  hotelId,
  isAmenityAreaAvailable,
  isCPB,
  isCheaperThanUsual,
  isCugAreaAvailable,
  isDbook,
  isFiltered,
  isGreatPrice,
  isLowest,
  isLowestForHotel,
  isMapCardListHotel,
  offerPosition,
  originalRoomName,
  pageName,
  partnerId,
  partnerRanking,
  position,
  positiveAmenities,
  price,
  priceDiff,
  rateFilterValues,
  redirectId,
  requestId,
  roomFilterValue,
  roomName,
  roomNameDimensions,
  roomType,
  searchCycleId,
  tags,
  taxFees,
}: {
  clickArea?: string;
  cugType?: string;
  currency?: string;
  isDbook?: boolean;
  isFiltered?: boolean;
  isLowest?: boolean;
  offerPosition?: number;
  partnerId?: string;
  position?: number;
  partnerRanking?: number;
  positiveAmenities?: string;
  price?: number;
  rateFilterValues?: Maybe<string>;
  roomFilterValue?: Maybe<string>;
  roomName?: Nullable<string>;
  roomType?: Nullable<string>;
  correlationId?: Maybe<string>;
  dayviewCorrelationId?: Nullable<string>;
  hotelId: string;
  basePrice?: number;
  hasAISummary?: boolean;
  taxFees?: number;
  pageName?: string;
  redirectId?: Nullable<string>;
  isGreatPrice?: boolean;
  discountPercentage?: Nullable<number>;
  isCugAreaAvailable?: boolean;
  isAmenityAreaAvailable?: boolean;
  hasRedirect?: boolean;
  isCPB?: boolean;
  groupName?: string;
  campaignName?: string;
  priceDiff?: number;
  searchCycleId?: Nullable<string>;
  requestId?: Nullable<string>;
  isLowestForHotel?: boolean;
  tags?: string[];
  isMapCardListHotel?: boolean;
  isCheaperThanUsual?: boolean;
  chatSessionId?: string;
  roomNameDimensions?: {
    bedType?: string;
    roomCategory?: string;
    lodgingType?: string;
    familyFriendly?: boolean;
  };
  originalRoomName?: Nullable<string>;
}) => ({
  price_selected_info: {
    is_dbook: isDbook,
    is_lowest: isLowest,
    is_lowest_for_hotel: isLowestForHotel,
    is_filtered: isFiltered,
    rate_filter_values: rateFilterValues,
    room_filter_value: roomFilterValue,
    ranking: position,
    partner_ranking: partnerRanking,
    partner_id: partnerId,
    price: price
      ? { currency, amount: Math.round(price), unit: 'WHOLE' }
      : undefined,
    price_vs_cheapest:
      typeof priceDiff !== 'undefined'
        ? {
            currency,
            amount: Math.round(priceDiff),
            unit: 'WHOLE',
          }
        : undefined,
    room_name: roomName,
    room_type: roomType
      ? ROOM_TYPE[roomType.toUpperCase()]
      : ROOM_TYPE.UNSET_ROOM_TYPE,
    bed_type: roomType,
    room_name_dimensions: roomNameDimensions
      ? {
          bed_type: roomNameDimensions.bedType,
          room_category: roomNameDimensions.roomCategory,
          lodging_type: roomNameDimensions.lodgingType,
          is_family_friendly: roomNameDimensions.familyFriendly,
        }
      : undefined,
    original_room_name: originalRoomName,
    positive_amenity_values: positiveAmenities,
    is_amenity_area_available: isAmenityAreaAvailable,
    click_area:
      CLICK_AREA[clickArea?.toUpperCase?.() as string] ||
      CLICK_AREA.UNSET_CLICK_AREA,
    cug_type:
      CUG_TYPE[cugType?.toUpperCase?.() as string] || CUG_TYPE.UNSET_CUG_TYPE,
    correlation_id: correlationId,
    day_view_correlation_id: dayviewCorrelationId,
    hotel_id: hotelId && parseInt(hotelId, 10),
    base_price: basePrice
      ? {
          currency,
          amount: Math.floor(basePrice),
          unit: 'WHOLE',
        }
      : undefined,
    tax_fees:
      typeof taxFees !== 'undefined'
        ? {
            currency,
            amount: Math.floor(taxFees),
            unit: 'WHOLE',
          }
        : undefined,
    page_name: pageName,
    redirect_id: redirectId,
    is_great_price: isGreatPrice,
    is_cug_area_available: isCugAreaAvailable,
    has_cug: !!discountPercentage,
    cug_percentage: discountPercentage ?? 0,
    has_redirect: hasRedirect,
    is_cpb: isCPB,
    group_name: groupName,
    campaign_name: campaignName,
    search_id: searchCycleId,
    request_id: requestId,
    has_ai_summary: hasAISummary,
    tags: tags?.join(','),
    offer_position: offerPosition,
    card_area: getPriceInfoCardArea({ isMapCardListHotel }),
    is_cheaper_than_usual: isCheaperThanUsual,
    chat_session_id: chatSessionId,
  },
});
